export default __webpack_public_path__ + "static/media/mergeAccountsSuccessPlaceholder.07f2e2d2.svg";